import detect from '../../core/detect'

export default class AddClass {
  get CLASSES() {
    return {
      isSelected: 'is-selected',
    };
  }

  constructor() {
    this.$targets = [...document.querySelectorAll('[data-grid-item]')];
    if (!this.$targets || !detect.isMobile()) return;
    this.onClick();
  }

  onClick() {
    this.$targets.forEach(item => {
      item.addEventListener('click', () => {
        item.classList.contains(this.CLASSES.isSelected) ? item.classList.remove(this.CLASSES.isSelected) : item.classList.add(this.CLASSES.isSelected);
      });
    })
  }
}
